module.exports = ".products-wrapper {\n  margin-bottom: 10px;\n}\n.clients-wrapper {\n  margin-bottom: 22px;\n}\n"